import { apiSlice } from '../../../../api/apiSlice';
// import { getRemainingTime } from './utils/helper';
import { testSource } from 'config/common';
import { addMinutes, differenceInSeconds } from 'date-fns';

const source = testSource;

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGsapeQuiz: builder.query<any, void>({
      query: () => {
        return {
          url: '/question/gsap/random',
        };
      },
      transformResponse: (res: any) => res.data,
      providesTags: ['GsapQuiz'],
      // NewAptitudeQuiz is from old code
    }),
    newCheckIncompleteGsap: builder.query<any, void>({
      query: () => {
        return {
          url: '/test/new-aptitude-test/incomplete',
          params: { source },
        };
      },
      transformResponse(res: any) {
        const startTime = res.data?.startTime;
        const endTime = addMinutes(new Date(startTime), 20);
        const currentTime = new Date();
        const timeLeftForQuiz = differenceInSeconds(endTime, currentTime);
        // const timeLeftForQuiz = getRemainingTime(
        //   startTime,
        //   totalTimeForQuizInMinutes
        // );
        if (res.data) {
          res.data.responses[0]['startTime'] = res.data?.startTime;
        }
        // const timeLeftPerCategory = res.data.responses.map((cat:any,index:number)=>{
        //   return  {"category":cat.category,"timeLeft": getRemainingTime(cat.startTime || res.data.startTime,cat.timeAllowed)}
        // });
        return { ...res.data, overallTimeLeft: timeLeftForQuiz };
      },
      providesTags: ['CurrentGsapQuiz'],
    }),
    newAptitudeTestScore: builder.query<any, void>({
      query: () => {
        return {
          url: '/test/new-aptitude-test/best-attempt',
        };
      },
      transformResponse: (res: any) => {
        return res.data;
      },
      providesTags: ['NewAptitudeQuizScore'],
    }),
    newAptitudeAttempt: builder.query<any, void>({
      query: () => {
        return {
          url: '/test/new-aptitude-test/attempt-status',
        };
      },
      transformResponse: (res: any) => {
        return res.data;
      },
    }),
    newStartGsapTest: builder.mutation({
      query(data: any) {
        const newData = { ...data, source, testType: 'GSAP' };
        const { ...body } = newData;
        return {
          url: `/test/new-aptitude-test/start`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['CurrentGsapQuiz'],
    }),
    newUpdateResponsesAptitude: builder.mutation({
      query(data: any) {
        const newData = { ...data, source };
        const { ...body } = newData;
        return {
          url: `/test/new-aptitude-test/update-responses`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['CurrentGsapQuiz'],
    }),
    finishGsapTest: builder.mutation({
      query() {
        const newData = { source };
        const { ...body } = newData;
        return {
          url: `/test/new-aptitude-test/finish-gsap`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [
        'Summary',
        'Onboarding',
        'NewAptitudeQuizScore',
        'CurrentNewAptitudeQuiz',
        'NewAptitudeQuiz',
      ],
    }),
  }),
});

export const {
  useGetGsapeQuizQuery,
  useNewCheckIncompleteGsapQuery,
  useNewAptitudeTestScoreQuery,
  useNewAptitudeAttemptQuery,
  useNewStartGsapTestMutation,
  useNewUpdateResponsesAptitudeMutation,
  useFinishGsapTestMutation,
} = extendedApiSlice;
